export const createSlotFromSession = (
	session: Sessions.Session,
): AvailableDates.SessionTimeSlot | null => {
	if (!session.selected_date || !session.available_date_id) return null;

	const startDate = new Date(session.selected_date);
	if (isNaN(startDate.getTime())) return null;

	const endDate = new Date(startDate.getTime() + 50 * 60000); // Add 50 minutes

	return {
		available_date_id: session.available_date_id,
		start_time: startDate.toISOString(),
		end_time: endDate.toISOString(),
	};
};
